var map = {
	"./arrow-circle-down.svg": 5235,
	"./discord.svg": 3086,
	"./facebook.svg": 5164,
	"./icons.svg": 8465,
	"./soldat.svg": 3210,
	"./steam-btn.svg": 5532,
	"./steam.svg": 7763,
	"./thd-header.svg": 7278,
	"./thd.svg": 4030,
	"./twitch.svg": 4054,
	"./twitter.svg": 4740,
	"./youtube.svg": 7082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;